import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import axios from "axios";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import PhoneInput from "react-phone-input-2";
import { useHistory, useParams } from "react-router-dom";
import calender from "../../assets/images/Calendar3.svg";
import del from "../../assets/images/delete.svg";
import Header from "../../layouts/Header";
import "../../assets/styles/local/profile.css";
import edit from "..//..//assets//icons/edit-2.svg";
import "..//..//assets/styles/local/UpdateMember.css";
import adddoc from "../../assets/images/Plus.svg";
import "../../assets/styles/local/flag.css";
import { geocodeByPlaceId } from "react-google-places-autocomplete";
import { AiOutlinePlus } from "react-icons/ai";

import { styled } from "@mui/material/styles";
import moment from "moment";
import { Switch } from "@mui/material";
import { Modal } from "react-bootstrap";
import CurrencyInput from "react-currency-input";
import "react-datepicker/dist/react-datepicker.css";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { BsChevronDown, BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import AppDatePicker from "../../components/Common/AppDatePicker";
import DeletePopUp from "../../components/Dailogs/DeletePopUp";
import DocumentUploaderWithProgress from "../../components/Common/Document_Uploader_With_Progress";
import {
  AddDocToUser,
  AddJobtypes,
  DeleteJobtypes,
  FetchJobtypes,
  FetchRoleModuleAccess,
  FetchUserById,
  Fetchdocumentbyuserid,
  UpdateJobtypes,
  deleteDoc,
  fetchLanguages,
  updateUser,
  fetchIdsType,
  fetchEmployeeType,
  fetchContractType,
  fetchCompanyCar,
  fetchReasons,
  FetchActiveUser,
  fetchUserCertification,
  UpdateProjectHiringStatus,
  insertDocToS3,
  FetchUserTitles,
  AddUpdateDeleteUserTitle,
} from "../../redux/actions/action";
import {
  SelectNav,
  PersonalInfoForm,
  LegalInformationForm,
  BankAccountForm,
  CompanyCarForm,
  CertificationList,
  ProvidedItems,
  WageScreen,
  TimeOffScreen,
  CustomDropdown,
} from "../../utils/addMember/helpers";
import {
  informationNavItems,
  documentNavItems,
} from "../../utils/addMember/navItems";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { API_URL, USER_UPDATE } from "..//..//redux/constants/type";
import { formattedCurrency } from "..//..//utils/helpers/calculateTime";
import noteyeIcon from "..//../assets/icons/Notshow.svg";
import eyeIcon from "..//../assets/icons/eye.svg";
import Calender from "../../assets/icons/Calendar with interaction.svg";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";
import lessthen from "../../assets/icons/lessthen.png";
import { EyeOutlined } from "@ant-design/icons";
import { getFilePreview } from "../../utils/filePreview/filePreview";
import FilePreviewModal from "../../utils/filePreview/FilePreviewModal";

const errorFields = {
  information: {
    name: "Please enter your name !",
    email: "Please enter your email !",
    password: "Please enter password.",
    phoneNumber: "Please enter your phone number",
    date: "Please enter date.",
    address: "Please enter address",
    zipCode: "Please enter ZIP-Code",
    language: "Please enter language",
  },
};
const errorBools = {
  name: false,
  email: false,
  password: false,
  phoneNumber: false,
  date: false,
  address: false,
  zipCode: false,
  language: false,
};

const UpdateMember = () => {
  const companyid = window.localStorage.getItem("companyid");
  const roleAccess = window.localStorage.getItem("roleid");
  const packageID = window.localStorage.getItem("packageId");
  const userfirstname = window.localStorage.getItem("firstname");
  const userlastname = window.localStorage.getItem("lastname");

  const fetchActiveUser = useSelector((state) => state.user.fetchActiveUser);
  const refNewStandardWageInput = useRef(null);
  const initialRender = React.useRef(true);
  let hiddenFileInput = useRef(null);
  const history = useHistory();

  const [filePreview, setFilePreview] = useState(null);

  const [information, setInfomation] = useState(true);
  const [wage, setWage] = useState(false);
  const [document, setDocument] = useState(false);
  const [timeOff, setTimeOff] = useState(false);
  const [FetchCompanyThemRes, setFetchCompanyThemRes] = useState([]);
  const [textcolor, setTextcolor] = useState("");
  const [showStatusDrop3, setShowStatusDrop3] = useState(false);
  const [backgroundcolor, setBackgroundcolor] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [roleOwnerDiseble, setRoleOwnerDiseble] = useState(false);
  const [roleManagerDiseble, setRoleManagerDiseble] = useState(false);
  const [weekHours, setWeekHours] = useState("");
  const [activeSlider, setActiveSlider] = useState(false);
  const [searchlang, setSearchlang] = useState("");
  const languages = window.localStorage.getItem("language");
  const [showPriorityDrop, setShowPriorityDrop] = useState(false);
  const [newUser, setNewUser] = useState([]);
  const [newdoc, setNewdoc] = useState([]);
  const [userData, setUserdata] = useState([]);
  const [fetchLanguageList, setFetchLanguageList] = useState([]);
  const [showStatusDrop2, setShowStatusDrop2] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [imageurl, setImageUrl] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [jobValue, setJobValue] = useState("");
  const [ziPcode, setZipcode] = useState("");
  const [taxnumber, setTaxnumber] = useState("");
  const [phonenumber, setPhonenumber] = useState("us");
  const [securitynumber, setSecuritynumber] = useState("");
  const [dateofbirth, setDateofbirth] = useState("");
  const [language, setLanguage] = useState("");
  const [wagerate, setWagerate] = useState("");
  const [billrate, setBillrate] = useState("");
  const [type, setType] = useState("");
  const [payment, setPayment] = useState("");
  const [password, setPassword] = useState("");
  const [abbreviation, setAbbreviation] = useState("");
  const [isactive, setIsactive] = useState();
  const [jobpost, setJobpost] = useState("");
  const roleID = window.localStorage.getItem("roleid");
  const [iscurrentcompany, setIscurrentcompany] = useState(
    "28830f30-b321-4662-a576-f23451677734",
  );
  const [isrequiretimesheetapproval, , setIsrequiretimesheetapproval] =
    useState("0");
  const [navErrors, setNavErrors] = useState({
    firstName: false,
    email: false,
    password: false,
    initials: false,
  });
  const [isallowmanualtime, setIsallowmanualtime] = useState("0");
  const [contracttype, setContracttype] = useState("");
  const [paymentperiod, setPaymentperiod] = useState("");
  const [jobid, setJobid] = useState("");
  const [roles, setRoles] = useState(process.env.REACT_APP_IS_MANAGER);
  const [roleid, setRoleid] = useState("");
  const [select, setSelect] = useState("nl");
  const onSelect = (code) => setSelect(code);
  const [comp, setComp] = useState("");
  const [changeComp, setChangeComp] = useState("");
  const [popups, setPopups] = useState(false);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [deleteDocument, setDeleteDocument] = useState(false);
  const [deleteRowIndex, setDeleteRowIndex] = useState(null);
  const [docname, setDocname] = useState("");
  const [docsize, setDocsize] = useState("");
  const [docdate, setDocdate] = useState("");
  const [up, setUp] = useState("");
  const [rolename, setRolename] = useState("");
  const [imgurl, setImgurl] = useState("");
  const [fullName, setFullName] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedOption1, setSelectedOption1] = useState("");
  const [selectedOption2, setSelectedOption2] = useState("");
  const [selectedOption3, setSelectedOption3] = useState("");
  const [selectedOption4, setSelectedOption4] = useState("");
  const [decodedPassword, setDecodedPassword] = useState("");
  const [passwordDots, setPasswordDots] = useState("");
  const [editdetailsofcoWorker, setEditdetailsofcoWorker] = useState(false);
  const [onlyOwnerEdite, setOnlyOwnerEdite] = useState(false);
  const [memberNonActiveAccess, setMemberNonActiveAccess] = useState(false);
  const roleModuleData = useSelector(
    (state) => state.user.FetchRoleModuleAccess,
  );
  const FetchCompanyDetails1 = useSelector(
    (state) => state.user.FetchCompanyDetails,
  );
  const dispatch = useDispatch();
  const newCreateUser = useSelector((state) => state.user.userCreate);
  const FetchUserData = useSelector((state) => state.user.FetchUserById);
  const FetchActiveUserData = useSelector(
    (state) => state.user.fetchActiveUser?.data,
  );
  const Document = useSelector((state) => state.user.fetchDocument);
  const addfile = useSelector((state) => state.user.AddDocument);
  const FetchJobtypesdata = useSelector((state) => state.user.FetchJobtypes);
  const AddJobtypesData = useSelector((state) => state.user.AddJobtypes);
  const UpdateJobtypesRes = useSelector((state) => state.user.UpdateJobtypes);
  const UserUpdatedata = useSelector((state) => state.user.userUpdate);
  const UpdateProjectHiringStatusRes = useSelector(
    (state) => state.user.UpdateProjectHiringStatusRes,
  );
  const FetchLanguagesData = useSelector(
    (state) => state.user.FetchlanguagesList,
  );
  const userid = window.localStorage.getItem("userid");
  const [fetchTransUpdateCoWorkers, setFetchTransUpdateCoWorkers] = useState(
    {},
  );
  const t = (key) => fetchTransUpdateCoWorkers?.[key] || "";
  const [authorisationRole, setAuthorisationRole] = useState("User");
  const Updateuserid = useParams();
  const UpdateUsuerId = Updateuserid.userid;
  const { projectId, projectHiringId } = useParams();
  const dltDoc = useSelector((state) => state.user.deleteDoc);
  const [newDate, setNewDate] = useState(new Date());
  const [updatedon, setUpdateOn] = useState("");
  const [docI, setdocI] = useState();
  const [showStatusDrop, setShowStatusDrop] = useState(false);
  const [errors, setErrors] = useState(errorBools);
  const [showTypeDrop, setShowTypeDrop] = useState(false);
  const [showContactDrop, setShowContactDrop] = useState(false);
  const [showPaymentDrop, setShowPaymentDrop] = useState(false);
  const [showJobDrop, setShowJobDrop] = useState(false);
  const [jobname, setJobname] = useState("");
  const [indexJobtype, setIndexJobtype] = useState();
  const [jobTypeEdit, setJobTypeEdit] = useState(false);
  const [editJobValue, setEditJobValue] = useState("");
  const [jobpostList, setJobpostList] = useState([]);
  const roleId = window.localStorage.getItem("roleid");
  const [paymentaccount, setPaymentaccount] = useState("");
  const [description, setDescription] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [size, setSize] = useState(perPage);
  const [leaves, setLeaves] = useState([]);
  const [totaldoc, setTotaldoc] = useState();
  const [hoverJobList, setHoverJobList] = useState(false);
  const [indexJobtypeIndex, setIndexJobtypeIndex] = useState("");
  const [current, setCurrent] = useState(1);
  const [fulLenghtDoc, setFulLenghtDoc] = useState(false);
  const [date, setDate] = useState(new Date());
  const [calendarIsOpen, setCalendarIsOpen] = useState(false);
  const [canGoBack, setCanGoBack] = useState(false);
  const [oddWorkingHours, setOddWorkingHours] = useState(0);
  const [evenWorkingHours, setEvenWorkingHours] = useState(0);
  const [payroll, setPayRoll] = useState(false);
  const [totalCertifications, setTotalCertifications] = useState([]);
  const [timesheetapproval, setTimeSheetApproval] = useState(false);
  const [oddLogId, setOddLogId] = useState("");
  const [evenLogId, setEvenLogId] = useState("");
  const [selectedInformationNav, setSelectedInformationNav] = useState(
    informationNavItems[0],
  );
  const [selectedDocumentNav, setSelectedDocumentNav] = useState(
    documentNavItems[0],
  );

  const { idsType, employeeType, contractType, companyCar, fetchedReasons } =
    useSelector((state) => state.user);

  const { insertedDoc } = useSelector((state) => state.user);
  const [personalForm, setPersonalForm] = useState({});

  const [legalForm, setLegalForm] = useState({});

  const [transportForm, setTransportForm] = useState({});
  const [bankAccounts, setBankAccounts] = useState([]);

  const [providedItems, setProvidedItems] = useState([]);

  const [certificationsList, setCertificationsList] = useState([]);
  const [timeOffEntries, setTimeOffEntries] = useState([]);
  const [applyToAllYear, setApplyToAllYear] = useState(false);
  const [paginationObj, setPaginationObj] = useState({
    totalRecords: 0,
    currentPage: 0,
    startRecordIndex: 0,
    endRecordIndex: 0,
    totalPages: 0,
    records: [],
  });

  const [evenDays, setEvenDays] = useState({
    // monday: "8",
    // tuesday: "8",
    // wednesday: "8",
    // thursday: "8",
    // friday: "8",
    // saturday: "0",
    // sunday: "0",
  });
  useEffect(() => {
    if (Object.keys(fetchTransUpdateCoWorkers).length > 0) {
      setEvenDays({
        [t("monday") || "monday"]: "8",
        [t("tuesday") || "tuesday"]: "8",
        [t("wednesday") || "wednesday"]: "8",
        [t("thursday") || "thursday"]: "8",
        [t("friday") || "friday"]: "8",
        [t("saturday") || "saturday"]: "0",
        [t("sunday") || "sunday"]: "0",
      });
    }
  }, [fetchTransUpdateCoWorkers]);

  const [oddDays, setOddDays] = useState({
    // monday: "8",
    // tuesday: "8",
    // wednesday: "8",
    // thursday: "8",
    // friday: "8",
    // saturday: "0",
    // sunday: "0",
  });
  useEffect(() => {
    if (Object.keys(fetchTransUpdateCoWorkers).length > 0) {
      setOddDays({
        [t("monday") || "monday"]: "8",
        [t("tuesday") || "tuesday"]: "8",
        [t("wednesday") || "wednesday"]: "8",
        [t("thursday") || "thursday"]: "8",
        [t("friday") || "friday"]: "8",
        [t("saturday") || "saturday"]: "0",
        [t("sunday") || "sunday"]: "0",
      });
    }
  }, [fetchTransUpdateCoWorkers]);

  const [canActiveStatusChange, setCanActiveStatusChange] = useState(false);
  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      // backgroundColor: theme.palette.common.white,
      fontWeight: 400,
      color: "#333333",
      fontSize: "14px",
      background: "#F1F1F1 0% 0% no-repeat padding-box",
      boxShadow: "0px 3px 6px #00000029",
      opacity: 1,
    },
  }));

  useEffect(() => {
    if (UpdateProjectHiringStatusRes != null) {
      if (UpdateProjectHiringStatusRes?.status === true) {
        history.push("/member-list");
      }
    }
  }, [UpdateProjectHiringStatusRes]);

  useEffect(() => {
    fetchScreenTranslations("Update-Co-Worker").then((res) => {
      setFetchTransUpdateCoWorkers(res);
    });
    dispatch(FetchRoleModuleAccess(roleID));
  }, []);
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleOptionChange1 = (event) => {
    setSelectedOption1(event.target.value);
  };
  const handleOptionChange2 = (event) => {
    setSelectedOption2(event.target.value);
  };
  const handleOptionChange3 = (event) => {
    setSelectedOption3(event.target.value);
  };
  const handleOptionChange4 = (event) => {
    setSelectedOption4(event.target.value);
  };
  const [profilePhoto, setProfilePhoto] = useState(null);
  const handleClick = (event) => {
    event.preventDefault();
    hiddenFileInput.current.click();
  };

  const StyledSwitch = styled(Switch)(({ theme }) => ({
    padding: 8,
    "& .MuiSwitch-track": {
      borderRadius: 22 / 2,
      "&:before, &:after": {
        content: '""',
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        width: 16,
        height: 16,
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "none",
      width: 16,
      height: 16,
      margin: 2,
    },
  }));

  const profileUpload = async (file) => {
    var formData = new FormData();
    formData.append("", file);
    try {
      const response = await axios.put(
        `${API_URL}/api/Files/UploadToS3`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      setImageUrl(response.data[0]);
    } catch (error) {}
  };

  const handleDeleteFun = () => {
    setImageUrl("");
    setDeleteModalShow(false);
  };

  const handleDeleteDocumentFun = () => {
    if (deleteRowIndex !== null) {
      dispatch(deleteDoc(deleteRowIndex));
    }
    setDeleteDocument(false);
    setDeleteRowIndex(null);
  };

  const certificationList = useSelector(
    (state) => state.user.fetchedCertification,
  );

  const onFileUploaded = (data) => {
    setImgurl(data.link);
    let newFileItem = {
      documentname: data[0].name,
      documentextension: data[0].type,
      documentcontent: "string",
      link: data[0].link,
      documentsize: data[0].size,
      ispossibledelete: 0,
      islocked: 0,
      type: selectedDocumentNav,
    };
    setNewdoc((prev) => [...prev, newFileItem]);
    setTimeout(() => {
      dispatch(AddDocToUser(userid, UpdateUsuerId, [newFileItem]));
    }, 1000);
  };

  useEffect(() => {
    if (addfile != null) {
      if (addfile.status == true) {
        dispatch(Fetchdocumentbyuserid(UpdateUsuerId));
      } else {
      }
    }
  }, [addfile]);

  useEffect(() => {
    if (FetchLanguagesData?.data?.status == true) {
      setFetchLanguageList(FetchLanguagesData?.data?.data);
    }
  }, [FetchLanguagesData]);

  useEffect(() => {
    if (FetchJobtypesdata != null) {
      if (FetchJobtypesdata?.data?.status === true) {
        setJobpostList(FetchJobtypesdata?.data?.data);
      } else {
      }
    }
  }, [FetchJobtypesdata]);

  useEffect(() => {
    if (UpdateJobtypesRes != null) {
      if (UpdateJobtypesRes?.status === true) {
        dispatch(FetchJobtypes());
      } else {
      }
    }
  }, [UpdateJobtypesRes]);

  useEffect(() => {
    if (UserUpdatedata != null) {
      if (UserUpdatedata?.status === true) {
        dispatch({ type: USER_UPDATE, data: {} });
        history.push("/member-list");
      }
    }
  }, [UserUpdatedata]);

  useEffect(() => {
    if (dltDoc != null) {
      if (dltDoc.status == true) {
        dispatch(Fetchdocumentbyuserid(UpdateUsuerId));
      } else {
      }
    }
  }, [dltDoc]);

  const handelCancels = () => {
    // if (changeComp !== "" || FetchUserData.data[0]?.dateofbirth !== "") {
    //   if (
    //     FetchUserData.data[0]?.dateofbirth !==
    //     moment.utc(startDate).format("YYYY-MM-DD")
    //   ) {
    //     setPopups(true);
    //   } else {
    //     // history.goBack();
    //   }
    // }
    // if (changeComp !== "") {
    //   setPopups(true);
    // } else {
    history.goBack();
    // }
  };

  useEffect(() => {
    dispatch(Fetchdocumentbyuserid(UpdateUsuerId));
    dispatch(fetchLanguages());
    dispatch(fetchIdsType());
    dispatch(fetchEmployeeType());
    dispatch(fetchContractType());
    dispatch(fetchCompanyCar());
    dispatch(fetchReasons());
    dispatch(FetchActiveUser(companyid));
    dispatch(fetchUserCertification());
    dispatch(FetchUserTitles());
  }, []);

  const PaginationChange = (page, pageSize) => {
    setCurrent(page);
    setSize(pageSize);
  };
  const PrevNextArrow = (current, type, originalElement) => {
    if (type === "prev") {
      return (
        <button style={{ width: "30px" }}>
          <AiOutlineLeft
            style={{
              color: "#A5A5A5",
              height: "12px",
              width: "20px",
            }}
          />
          {/* <i className="fa fa-angle-double-left"></i> */}
        </button>
      );
    }
    if (type === "next") {
      return (
        <button style={{ width: "30px" }}>
          <AiOutlineRight
            style={{
              color: "#A5A5A5",
              height: "12px",
              width: "20px",
            }}
          />
          {/* <i className="fa fa-angle-single-right"></i> */}
        </button>
      );
    }
    return originalElement;
  };
  const PerPageChange = (value) => {
    setSize(value);
    const newPerPage = Math.ceil(totaldoc / value);
    if (current > newPerPage) {
      setCurrent(newPerPage);
    }
  };
  const getData = (current, pageSize) => {
    // Normally you should get the data from the server
    return newdoc.slice((current - 1) * pageSize, current * pageSize);
  };

  // const [ documentList, setDocumentList ] = useState();

  useEffect(() => {
    if (!initialRender.current) {
      if (Document != null) {
        if (Document?.status == true && !newdoc.length > 0) {
          setNewdoc(Document?.data);
          setTotaldoc(Document?.data?.length);
          // setDocname(Document.data[ 0 ]?.documentname)
          // setDocsize(Document.data[ 0 ]?.documentsize)
          // setDocdate(Document.data[ 0 ]?.date)
          // setUp(Document.data[ 0 ]?.uploadedby)
        } else {
        }
      }
    } else {
      initialRender.current = false;
    }
  }, [Document]);

  const calculatePagination = (pageNumber) => {
    let records = newdoc || [];
    let tempPaginationObj = {
      totalRecords: records.filter((rec) => rec?.type === selectedDocumentNav)
        .length,
      currentPage: pageNumber,
      startRecordIndex: Math.max(10 * pageNumber - 9, 1),
      endRecordIndex: Math.min(
        10 * pageNumber,
        records.filter((rec) => rec?.type === selectedDocumentNav).length,
      ),
      totalPages: Math.ceil(
        records.filter((rec) => rec?.type === selectedDocumentNav).length / 10,
      ),
      records: records
        .filter((rec) => rec?.type === selectedDocumentNav)
        ?.slice((pageNumber - 1) * 10, pageNumber * 10),
    };
    setPaginationObj({ ...tempPaginationObj });
  };

  const handleAddressSelect = (address) => {
    const { place_id } = address;
    geocodeByPlaceId(place_id)
      .then((res) => {
        if (res && res[0] && res[0].address_components) {
          const { long_name: postalCode = "" } =
            res[0].address_components.find((c) =>
              c.types.includes("postal_code"),
            ) || {};
          // setZipcode(postalCode);

          if (!address.description.includes(postalCode)) {
            setZipcode(postalCode);
          }
        }
      })
      .catch((err) => {
        console.log("Error while fetching address meta ", err);
      })
      .finally((done) => {
        console.log("Address API Call Completed ", done);
      });
  };

  useEffect(() => {
    calculatePagination(1);
  }, [newdoc, selectedDocumentNav]);

  useEffect(() => {
    dispatch(FetchUserById(UpdateUsuerId));
  }, []);
  useEffect(() => {
    dispatch(FetchJobtypes());
  }, []);

  ////////////////////FETCH UESERID  API ////////////
  useEffect(() => {
    if (FetchUserData != null) {
      if (FetchUserData.status == true) {
        setUserdata(FetchUserData.data);
        // setIsactive(FetchUserData.data[ 0 ]?.isactive === 1 || 2 ? true : false);
        setIsactive(
          FetchUserData.data[0]?.isactive === 1
            ? true
            : FetchUserData.data[0]?.isactive === 2
              ? true
              : FetchUserData.data[0]?.isactive === 0
                ? false
                : "",
        );
        setCanActiveStatusChange(FetchUserData.data[0]?.isactive !== 2);
        setImageUrl(FetchUserData.data[0]?.imageurl);

        setWeekHours(FetchUserData.data[0]?.weekhours);

        setTaxnumber(FetchUserData.data[0]?.taxnumber);
        setSecuritynumber(FetchUserData.data[0]?.securitynumber);

        setWagerate(FetchUserData.data[0]?.wagerate);
        setBillrate(FetchUserData.data[0]?.billrate);
        setType(FetchUserData.data[0]?.type);
        setPaymentperiod(FetchUserData.data[0]?.paymentperiod);
        setRoleid(FetchUserData.data[0]?.roledetails[0]?.roleid);
        setRolename(FetchUserData.data[0]?.roledetails[0]?.rolename);
        setContracttype(FetchUserData.data[0]?.contracttype);
        setUpdateOn(FetchUserData.data[0]?.updatedon);
        setRoleid(FetchUserData.data[0]?.roledetails[0]?.roleid);
        setJobname(FetchUserData?.data[0]?.jobtypename);
        setJobid(FetchUserData?.data[0]?.jobid);
        setPaymentaccount(FetchUserData?.data[0]?.paymentaccount);
        setDescription(FetchUserData?.data[0]?.description);
        const updatedLeaveData = FetchUserData?.data[0]?.usertimeoff.map(
          (entry) => ({
            ...entry,
            from: entry.from ? moment.utc(entry.from).format("DD.MM.YYYY") : "",
            to: entry.to ? moment.utc(entry.to).format("DD.MM.YYYY") : "",
          }),
        );
        setLeaves(updatedLeaveData);
        setActiveSlider(FetchUserData.data[0]?.isactive === 1 ? true : false);
        const userData = FetchUserData.data[0];
        setPersonalForm({
          firstname: userData.firstname || "",
          email: userData.email || "",
          initials: userData.initials || "",
          title: userData.title || "",
          password: userData.password,
          userid: userData.userid || "",
          address: userData.address || "",
          businessTelephone: userData.businessTelephone || "",
          personalTelephone: userData.personalTelephone || "",
          dateofbirth: userData.dateofbirth
            ? new Date(userData.dateofbirth)
            : "",
          birthPlace: userData.birthPlace || "",
          personalEmail: userData.personalEmail || "",
          countryofBirth: userData.countryofBirth || "",
          nationality: userData.nationality || "",
          emergencyContact: userData.emergencyContact || "",
          gender: userData.gender || "",
          maritalStatus: userData.maritalStatus || "",
          emergencyTelephone: userData.emergencyTelephone || "",
          relation: userData.relation || "",
          language: userData.language || "",
        });

        const legalData = { ...userData?.userlegal?.[0] };
        if (legalData["pensionExpectedDate"]) {
          legalData["pensionExpectedDate"] = new Date(
            legalData["pensionExpectedDate"],
          );
        }
        if (legalData["contractStartDate"]) {
          legalData["contractStartDate"] = new Date(
            legalData["contractStartDate"],
          );
        }
        if (legalData["contactEndDate"]) {
          legalData["contactEndDate"] = new Date(legalData["contactEndDate"]);
        }
        if (legalData["trialPeriodend"]) {
          legalData["trialPeriodend"] = new Date(legalData["trialPeriodend"]);
        }
        if (legalData["validity"]) {
          legalData["validity"] = new Date(legalData["validity"]);
        }
        setLegalForm(legalData);
        setBankAccounts(userData?.userfinancial);
        if (userData?.userbenefits && userData?.userbenefits?.[0]) {
          const tranportFormData = userData?.userbenefits?.[0];
          tranportFormData["leasingStartDate"] = tranportFormData[
            "leasingStartDate"
          ]
            ? new Date(tranportFormData["leasingStartDate"])
            : "";
          setTransportForm(tranportFormData);
          console.log(userData?.usercertification);
        }

        setProvidedItems(
          userData?.userprovideditems && userData?.userprovideditems.length > 0
            ? userData?.userprovideditems.map((item) => {
                return {
                  ...item,
                  dateProvided: new Date(item["dateProvided"]),
                };
              })
            : [],
        );
        setTimeOffEntries(userData?.usertimeoff);
        if (userData?.userlogtimer && userData?.userlogtimer?.length > 0) {
          for (let key of userData?.userlogtimer) {
            if (key?.type === "even") {
              const obj = { ...key };
              delete obj.type;
              delete obj.weekNumber;
              setEvenLogId(obj.userLogTimerid);
              delete obj.userLogTimerid;
              setEvenDays(obj);
            } else {
              const obj = { ...key };
              delete obj.type;
              delete obj.weekNumber;
              setOddLogId(obj.userLogTimerid);
              delete obj.userLogTimerid;
              setOddDays(obj);
            }
          }
        }
        setTotalCertifications(userData?.usercertification);
        setTimeSheetApproval(userData?.timesheetapproval == 0 ? false : true);
        setPayRoll(userData?.payroll == 0 ? false : true);
        setApplyToAllYear(userData?.applyToAllYear == 0 ? false : true);
      } else {
      }
    }
  }, [FetchUserData]);

  React.useEffect(() => {
    if (!initialRender.current) {
      if (FetchCompanyDetails1 != null) {
        if (FetchCompanyDetails1.status == true) {
          setFetchCompanyThemRes(FetchCompanyDetails1.data);
          setTextcolor(FetchCompanyDetails1.data[0]?.textcolor);
          setBackgroundcolor(FetchCompanyDetails1.data[0]?.backgroundcolor);
          // setCompenylLogo(FetchCompanyDetails1.data[0]?.companylogo)
        } else {
        }
      }
    } else {
      initialRender.current = false;
    }
  }, [FetchCompanyDetails1]);

  const convertDatesToISO = () => {
    const updatedData = leaves?.map((entry) => ({
      ...entry,
      from: entry.from
        ? moment.utc(entry.from, "DD.MM.YYYY").format("YYYY-MM-DD")
        : "",
      to: entry.to
        ? moment.utc(entry.to, "DD.MM.YYYY").format("YYYY-MM-DD")
        : "",
    }));
    return updatedData;
  };
  useEffect(() => {
    if (!initialRender.current) {
      if (newCreateUser != null) {
        if (newCreateUser.status == true) {
          setNewUser(newCreateUser.data);
        } else {
        }
      }
    } else {
      initialRender.current = false;
    }
  }, [newCreateUser]);

  const handleChange = () => {
    // const updateErrors = { ...errors };
    // if (fullName === "") {
    //   updateErrors.name = true;
    // }
    // if (email === "") {
    //   updateErrors.email = true;
    // }

    // if (password === "") {
    //   updateErrors.password = true;
    // }

    // if (
    //   Object.keys(errors).some(
    //     (singleError) => updateErrors[singleError] === true
    //   )
    // ) {
    //   setErrors(updateErrors);
    //   setInfomation(true);
    //   setWage(false);
    //   setDocument(false);
    //   setTimeOff(false);
    //   return;
    // }
    // if (emailError) {
    //   setInfomation(true);
    //   setWage(false);
    //   setDocument(false);
    //   setTimeOff(false);
    //   return;
    // }

    // if (fullName !== "" && email !== "" && password !== "") {
    // setErrors({ ...errorBools });
    const fnames = fullName.split(" ");
    const firstName = fnames[0];
    fnames.shift();
    const lastName = fnames.join(" ") || "";
    const leaveData = convertDatesToISO();
    dispatch(
      updateUser({
        isactive: activeSlider ? 1 : 0,
        userid: UpdateUsuerId,
        actionTakerUserId: userid,
        ...personalForm,
        lastname: "",
        userlegal: [legalForm],
        userprovideditems: providedItems,
        userbenefits: [transportForm],
        usercertification: totalCertifications,
        usertimeoff: timeOffEntries,
        userfinancial: bankAccounts,
        applyToAllYear: applyToAllYear === true ? 1 : 0,
        oddWorkingHours,
        evenWorkingHours,
        timesheetapproval: timesheetapproval === true ? 1 : 0,
        payroll: payroll === true ? 1 : 0,
        // leaveData,
        isverified: 0,
        isrequiretimesheetapproval: 0,
        isallowmanualtime: 0,
        isdeleted: 0,
        iscurrentcompany,

        isallowmanualtime,
        imageurl,
        billrate,
        contracttype,
        paymentperiod,
        type,
        wagerate,
        jobid: jobid ?? "",
        roleid,
        userlogtimer: [
          {
            userLogTimerid: evenLogId,
            type: "even",
            weekNumber: moment().week(),
            ...evenDays,
          },
          {
            userLogTimerid: oddLogId,
            type: "odd",
            weekNumber: moment().week(),
            ...oddDays,
          },
        ],
      }),
    );
    setCanGoBack(true);
    // }
  };

  const customLabels = {
    US: "USA",
    GB: "UK",
    FR: "FR",
    DE: "GR",
    IT: "IT",
    IN: "IN",
    NL: "NL",
  };

  function convertToDots(password) {
    let passwordDots = "";
    for (let i = 0; i < password.length; i++) {
      passwordDots += ".";
    }
    return passwordDots;
  }
  useEffect(() => {
    if (AddJobtypesData != null) {
      if (AddJobtypesData?.status === true) {
        setJobid(AddJobtypesData?.data?.jobtypeid);
        // dispatch(Fetchdocumentbyuserid(userid))
        dispatch(FetchJobtypes());
        setShowJobDrop(false);
        setJobValue("");
      } else {
      }
    }
  }, [AddJobtypesData]);

  const options = [{ value: "English" }, { value: "Dutch" }];
  const typeoptions = [
    { value: t("Hourly") },
    { value: t("Daily") },
    { value: t("Fixed") },
  ];

  // const contactTypeoptions = [ { value: "Contract" }, { value: fetchTransUpdateCoWorkers[ 28 ]?.translation } ];

  const contactTypeoptions = [
    { value: t("Freelancer") },
    { value: t("Contract ") },
  ];

  const pymentoptions = [
    { value: t("Weekly") },
    { value: t("Daily") },
    { value: t("Monthly") },
  ];
  const refContactTypeDropDownContainer = useRef();
  const refContactTypeDropDownContainerExclude = useRef();
  const handleMouseDownContactDD = (event) => {
    if (
      refContactTypeDropDownContainer.current &&
      !refContactTypeDropDownContainer.current.contains(event.target) &&
      !refContactTypeDropDownContainerExclude.current.contains(event.target)
    ) {
      setShowContactDrop(false);
    }
  };
  useEffect(() => {
    if (showContactDrop) {
      window.addEventListener("mousedown", handleMouseDownContactDD);
    } else {
      window.addEventListener("mousedown", handleMouseDownContactDD);
    }
    return () => {
      window.removeEventListener("mousedown", handleMouseDownContactDD);
    };
  }, [showContactDrop]);

  const refJobTypeDropDownContainer = useRef();
  const refJobTypeDropDownContainerExclude = useRef();
  const handleMouseDownJobDD = (event) => {
    if (
      refJobTypeDropDownContainer.current &&
      !refJobTypeDropDownContainer.current.contains(event.target) &&
      !refJobTypeDropDownContainerExclude.current.contains(event.target)
    ) {
      setShowJobDrop(false);
    }
  };
  useEffect(() => {
    if (showJobDrop) {
      window.addEventListener("mousedown", handleMouseDownJobDD);
    } else {
      window.addEventListener("mousedown", handleMouseDownJobDD);
    }
    return () => {
      window.removeEventListener("mousedown", handleMouseDownJobDD);
    };
  }, [showJobDrop]);
  const refLanguageContainer = useRef();
  const refLanguageContainerExclude = useRef();
  const handleMouseDownContactLanguage = (event) => {
    if (
      refLanguageContainer.current &&
      !refLanguageContainer.current.contains(event.target) &&
      !refLanguageContainerExclude.current.contains(event.target)
    ) {
      setShowStatusDrop3(false);
    }
  };
  useEffect(() => {
    if (showStatusDrop3) {
      window.addEventListener("mousedown", handleMouseDownContactLanguage);
    } else {
      window.addEventListener("mousedown", handleMouseDownContactLanguage);
    }
    return () => {
      window.removeEventListener("mousedown", handleMouseDownContactLanguage);
    };
  }, [showStatusDrop3]);
  const refPaymentTypeDropDownContainer = useRef();
  const refPaymentTypeDropDownContainerExclude = useRef();
  const handleMouseDowPaymentDD = (event) => {
    if (
      refPaymentTypeDropDownContainer.current &&
      !refPaymentTypeDropDownContainer.current.contains(event.target) &&
      !refPaymentTypeDropDownContainerExclude.current.contains(event.target)
    ) {
      setShowPaymentDrop(false);
    }
  };
  useEffect(() => {
    if (showPaymentDrop) {
      window.addEventListener("mousedown", handleMouseDowPaymentDD);
    } else {
      window.addEventListener("mousedown", handleMouseDowPaymentDD);
    }
    return () => {
      window.removeEventListener("mousedown", handleMouseDowPaymentDD);
    };
  }, [showPaymentDrop]);
  const refTypeDropDownContainer = useRef();
  const refTypeDropDownContainerExclude = useRef();
  const handleMouseDowTypeDD = (event) => {
    if (
      refTypeDropDownContainer.current &&
      !refTypeDropDownContainer.current.contains(event.target) &&
      !refTypeDropDownContainerExclude.current.contains(event.target)
    ) {
      setShowTypeDrop(false);
      setShowStatusDrop3(false);
    }
  };
  useEffect(() => {
    if (showTypeDrop || showStatusDrop3) {
      window.addEventListener("mousedown", handleMouseDowTypeDD);
    } else {
      window.addEventListener("mousedown", handleMouseDowTypeDD);
    }
    return () => {
      window.removeEventListener("mousedown", handleMouseDowTypeDD);
    };
  }, [showTypeDrop, showStatusDrop3]);

  const pdfdownload = (event, documentid, documentname) => {
    axios({
      method: "post",
      url: `${API_URL}/api/Files/DownloadToS3?documentid=` + documentid,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
      // data: {
      //   message?.message
      // },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      // var el = document.createElement('div');
      const document = window.document || {};
      const link = document.createElement("a");
      link.href = url;
      link.download = documentname;
      document.body.appendChild(link);
      link.click();
      // link.setAttribute("download", `FinalDocument.pdf`);

      // Append to html link element page
      // document.body.appendChild(link);

      // Start download
      // link.click();

      // Clean up and remove the link
      // link.parentNode.removeChild(link);
      // return docFileDownload;
      // }, 1000)
    });
  };
  const roundFileSize = (size, precision) => {
    const units = ["B", "KB", "MB", "GB", "TB"];
    let index = 0;

    while (size >= 1024 && index < units.length - 1) {
      size /= 1024;
      index++;
    }

    return `${Number(size)?.toFixed(precision)} ${units[index]}`;
  };

  useEffect(() => {
    const sum = Object.values(evenDays).reduce((acc, curr) => {
      if (!isNaN(parseInt(curr))) acc = acc + parseInt(curr);
      else acc += 0;
      return acc;
    }, 0);
    setEvenWorkingHours(sum);
  }, [evenDays]);

  useEffect(() => {
    const sum = Object.values(oddDays).reduce((acc, curr) => {
      if (!isNaN(parseInt(curr))) acc = acc + parseInt(curr);
      else acc += 0;
      return acc;
    }, 0);
    setOddWorkingHours(sum);
  }, [oddDays]);

  React.useEffect(() => {
    if (roleModuleData?.status === 200) {
      for (let i = 0; i < roleModuleData?.data?.data?.length; i++) {
        if (
          roleModuleData?.data?.data[i]?.moduleid ===
            "08da4e8a-6050-40db-8d54-5751dc976021" &&
          roleModuleData?.data?.data[i]?.accesslevelsid ===
            "08da33e9-5a64-4f8c-8d88-49e4982df310" &&
          roleModuleData?.data?.data[i]?.featureid ===
            "08da3f0d-0371-4dd3-8c86-e51222d60039"
        ) {
          setEditdetailsofcoWorker(true);
        } else if (
          roleModuleData?.data?.data[i]?.moduleid ===
            "08da4e8a-6050-40db-8d54-5751dc976021" &&
          roleModuleData?.data?.data[i]?.accesslevelsid ===
            "08da33e9-5a64-4f8c-8d88-49e4982df310" &&
          roleModuleData?.data?.data[i]?.featureid ===
            "08da3f0d-0371-4dd3-8c86-e51222d60040"
        ) {
          setMemberNonActiveAccess(true);
        } else if (
          roleModuleData?.data[i]?.moduleid ===
            "08da4e8a-6050-40db-8d54-5751dc976021" ||
          roleModuleData?.data?.data[i]?.accesslevelsid ===
            "08da33e9-5a64-4f8c-8d88-49e4982df310" ||
          roleModuleData?.data?.data[i]?.featureid ===
            "08da3f0d-0371-4dd3-8c86-e51222d60036"
        ) {
          setOnlyOwnerEdite(true);
        }
      }
    } else {
    }
  }, [roleModuleData]);

  const getNameAbbrivation = useMemo(() => {
    if (fullName) {
      const arr = fullName.split(" ").filter((x) => Boolean(x));
      arr.forEach((x) => {
        return x.trim();
      });
      if (arr.length > 0) {
        if (arr.length === 1) {
          return arr[0].slice(0, 2)?.toUpperCase();
        } else if (arr.length > 1) {
          return `${arr[0].slice(0, 1)?.toUpperCase()}${arr[1]
            .slice(0, 1)
            ?.toUpperCase()}`;
        }
      }
    }
  }, [fullName]);

  const [jobHover, setJobHover] = useState(false);

  const handleJobName = () => {
    if (jobname && jobname !== "") {
      if (jobname.length <= 12) {
        return jobname;
      } else if (jobname.length > 12 && showJobDrop) {
        return "..." + jobname.slice(-12);
      } else if (jobname.length > 12 && !showJobDrop) {
        return jobname.slice(0, 12) + "...";
      }
      return "Select";
    } else {
      return "Select";
    }
  };
  const [dateError, setDateError] = useState(false);
  const datePickerFunc = (val) => {
    if (val != undefined) {
      setDate(val);
    }
    setCalendarIsOpen(!calendarIsOpen);
  };

  const renderError = (error) => {
    return (
      <p
        style={{
          color: "red",
          margin: 0,
          fontSize: "11px",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          justifyContent: "center",
          marginTop: "-1rem",
        }}
      >
        {error}
      </p>
    );
  };
  const handleTabChange = (tab) => {
    const obj = {
      firstName: false,
      email: false,
      password: false,
      initials: false,
    };
    const checkErrors = () => {
      if (!personalForm.firstname) obj.firstName = true;
      if (!personalForm.email) obj.email = true;
      if (!personalForm.initials) obj.initials = true;
      if (!personalForm.password) obj.password = true;
      if (Object.keys(obj).some((item) => obj[item] === true))
        setNavErrors(obj);
    };
    checkErrors();
    if (tab === "information") {
      setInfomation(true);
      setWage(false);
      setDocument(false);
      setTimeOff(false);
    } else if (
      tab === "wagenrole" &&
      !Object.keys(obj).some((item) => obj[item] === true)
    ) {
      setInfomation(false);
      setWage(true);
      setDocument(false);
      setTimeOff(false);
    } else if (
      tab === "document" &&
      !Object.keys(obj).some((item) => obj[item] === true)
    ) {
      checkErrors();
      setInfomation(false);
      setWage(false);
      setDocument(true);
      setTimeOff(false);
    } else if (
      tab === "timeoff" &&
      !Object.keys(obj).some((item) => obj[item] === true)
    ) {
      checkErrors();
      setInfomation(false);
      setWage(false);
      setDocument(false);
      setTimeOff(true);
    }
    // }
  };

  const ascTakingDatafromChild = (asc) => {
    setChangeComp(asc);
  };

  return (
    <>
      <Header
        leftComponent={
          projectId !== undefined && (
            <h6
              className="Co-Workers1 ms-3"
              style={{
                fontSize: "clamp(20px, 1.354vw, 1.354vw)",
              }}
            >
              {t("Co-Workers")}
            </h6>
          )
        }
      />

      <RouteLeavingGuard
        when={changeComp !== ""}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          // This case it blocks the navigation when:
          // 1. the login form is dirty, and
          // 2. the user is going to 'sign-up' scene.
          //    (Just an example, in real case you might
          //     need to block all location regarding this case)
          if (changeComp !== "") {
            if (
              !["/member", `/updat-member/${UpdateUsuerId}`].includes(
                location.pathname,
              )
            ) {
              if (location.pathname === "/member-list" && !canGoBack) {
                return true;
              } else if (location.pathname === "/member-list" && canGoBack)
                return false;
              return true;
            }
          }
          return false;
        }}
      />
      <div className="mx-2">
        <div className="container-fluid d-flex gap-3 flex-column">
          <div className="d-flex justify-content-between align-items-center mx-md-2 mx-sm-1 mb-2">
            {projectId === undefined ? (
              <h6
                className="Co-Workers1 ms-3"
                style={{
                  fontSize: "clamp(20px, 1.354vw, 1.354vw)",
                }}
              >
                {t("Co-Workers")}
              </h6>
            ) : (
              <div className="d-flex flex-wrap gap-4 ps-4">
                <div
                  className="d-flex pe-3 rounded"
                  style={{
                    background: "#FFFFFF",
                    alignItems: "center",
                  }}
                >
                  <p className="ps-4 projectText2">Project</p>
                  <p className="ps-5 orderCode mb-0">ID &nbsp;{projectId}</p>
                  <p className="ps-5 orderCode mb-0">
                    <img src={lessthen} alt="lessthen" />
                  </p>
                  <p
                    style={{
                      color: "#333333",
                      fontSize: "16px",
                    }}
                    className="ps-5 orderCode mb-0"
                  >
                    New Hiring{" "}
                  </p>
                </div>
              </div>
            )}
            <div className="d-flex justify-content-end gap-4 ascHideForMobile">
              <button
                className="canclebtn-add invite-btn-aspect-ratio  cancle-btn-aspect-ratio"
                onClick={handelCancels}
                style={{ wordBreak: "break-all" }}
              >
                {t("Cancel ")}
              </button>
              <button
                disabled={
                  personalForm.firstname &&
                  personalForm.email &&
                  personalForm.initials &&
                  personalForm.password
                    ? false
                    : true
                }
                className="custom-button-hire invite-btn-aspect-ratio"
                onClick={handleChange}
                style={{ wordBreak: "break-all" }}
              >
                {/* {fetchTransUpdateCoWorkers[15]?.translation} */}
                Save
              </button>

              {projectId !== undefined && (
                <button
                  disabled={
                    personalForm.firstname &&
                    personalForm.email &&
                    personalForm.initials &&
                    personalForm.password
                      ? false
                      : true
                  }
                  className="invitebtn-add-member invite-btn-aspect-ratio"
                  onClick={() => {
                    dispatch(
                      UpdateProjectHiringStatus(
                        projectHiringId,
                        process.env.REACT_APP_HIRED,
                      ),
                    );
                  }}
                  style={{ wordBreak: "break-all" }}
                >
                  Hire
                </button>
              )}
            </div>
          </div>
          <div className="row  mx-md-2    ">
            {/* ///////////////////// RIGHT SIDE //////////////// */}
            <div className="col-xl-4 col-lg-12  col-md-12 col-sm-12 col-12 col-xxl-3  ">
              <div
                className="columnfirst me-3"
                style={{
                  backgroundColor: `${backgroundcolor}`,
                }}
              >
                <div className="py-5 ">
                  <h4
                    className="headingprofile"
                    style={{
                      color: `${textcolor}`,
                      wordBreak: "break-all",
                      fontWeight: 800,
                    }}
                  >
                    {t("Profile")}
                  </h4>
                </div>

                <div className="d-flex justify-content-center pt-4 mt-xxl-3 ">
                  <input
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    ref={hiddenFileInput}
                    onChange={(event) => {
                      const fileUploaded = event.target.files[0];
                      if (fileUploaded) {
                        const image = URL.createObjectURL(fileUploaded);
                        setProfilePhoto(image);
                        profileUpload(fileUploaded);
                        setChangeComp(image);
                      } else {
                        return;
                      }
                    }}
                  />

                  {imageurl ? (
                    <div className="profile-image1 ">
                      <img
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: "100%",
                          objectFit: "cover",
                        }}
                        src={imageurl}
                        alt=""
                      />
                    </div>
                  ) : personalForm.initials ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        className="add-profile-image"
                        style={{
                          border: `1px #00256E dashed`,
                          borderRadius: "50%",
                          backgroundColor: "#94a6c7",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "white",
                        }}
                      >
                        {personalForm.initials ? personalForm.initials : ""}
                      </div>
                      <div className="d-flex justify-content-center pt-3 ">
                        <h6
                          className="mt-2"
                          style={{
                            fontSize: "12px",
                            cursor: "pointer",
                            color: "#A5A5A5",
                            wordBreak: "break-all",
                          }}
                          onClick={handleClick}
                        >
                          {t("Change")}
                        </h6>
                        <img
                          className="mx-2"
                          style={{
                            cursor: "pointer",
                          }}
                          src={del}
                          alt="delete"
                          onClick={() => setImageUrl("")}
                        />
                      </div>
                    </div>
                  ) : (
                    <div
                      className="profile-image1"
                      style={{
                        border: `1px #00256E dashed`,
                        // minWidth: "240px",
                        // minHeight: "240px",
                        height: "15vw",
                        width: "15vw",
                        borderRadius: "50%",
                      }}
                    >
                      <div
                        style={{
                          marginTop: "40%",
                          cursor: "pointer",
                        }}
                      >
                        <AiOutlinePlus
                          style={{
                            fontSize: "1.5rem",
                            fontWeight: "bold",
                            color: "#00246A",
                          }}
                          className="responsive-check"
                          onClick={handleClick}
                        />
                        <br />
                        <p
                          className="company"
                          onClick={handleClick}
                          style={{
                            wordBreak: "break-all",
                          }}
                        >
                          {t("Add a photo")}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
                <div style={{ height: "50px" }}>
                  {imageurl && (
                    <div className="d-flex justify-content-center pt-3 ">
                      <h6
                        className="mt-2"
                        style={{
                          fontSize: "12px",
                          cursor: "pointer",
                          color: "#A5A5A5",
                          wordBreak: "break-all",
                        }}
                        onClick={handleClick}
                      >
                        {t("Change")}
                      </h6>
                      <img
                        className="mx-2"
                        style={{ cursor: "pointer" }}
                        src={del}
                        alt="delete"
                        onClick={() => setImageUrl("")}
                      />
                    </div>
                  )}
                </div>

                <div className="pt-xxl-5 mt-xxl-3 mt-xl-2 mt-lg-2 mt-sm-2 ">
                  <input
                    className="noborder2 text-center"
                    disabled
                    type="text"
                    placeholder="Name"
                    style={{
                      color: "#333333",
                      fontSize: "18px",
                      fontWeight: "bold",
                      opacity: 0.5,
                    }}
                    onChange={(e, value) => {
                      setFullName(e.target.value);
                      setChangeComp(e.target.value);
                    }}
                    value={personalForm?.firstname}
                  />
                  {/* <h3 style={{ color: `${textcolor}`, fontSize: "18px", fontWeight: "700" }}> {`${firstname}` + " " + `${lastname}`}</h3> */}
                </div>
              </div>
            </div>
            {/* ////////////////////// LEFT SIDE //////////////// */}
            <div
              className={
                showStatusDrop3
                  ? "col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12 col-xxl-9   leftscreen drop-space"
                  : "col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12 col-xxl-9   leftscreen "
              }
              // className="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12 col-xxl-9   leftscreen "
              style={{
                backgroundColor: `${backgroundcolor}`,
                // minHeight: "646.63px",
              }}
            >
              <div className="leftscreen-container">
                <div className="row  ">
                  <div className="col-6 col-md-3 p-0">
                    <div
                      className={
                        information
                          ? "tagcolor information-update pt-5 pe-5 info-item"
                          : "info-item pe-5 information2 pt-5"
                      }
                      onClick={() => handleTabChange("information")}
                      style={{ wordBreak: "break-all" }}
                    >
                      {t("Information")}
                      {information && <div className="horizontal-update" />}
                    </div>
                  </div>
                  <div className="col-6 col-md-3 p-0">
                    <div
                      className={wage ? "tagcolor wage pt-5" : "wage2 pt-5"}
                      onClick={() => handleTabChange("wagenrole")}
                      style={{ wordBreak: "break-all" }}
                    >
                      {t("Wage and role")}
                    </div>
                    <hr
                      className={wage ? "horizontalWage22" : "horizontal1"}
                      style={{ color: "#333333" }}
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-md-3 p-0">
                    <div className="">
                      <div
                        className={
                          document
                            ? "tagcolor documents-update pt-5"
                            : "documents2 pt-5 "
                        }
                        onClick={() => handleTabChange("document")}
                        style={{
                          wordBreak: "break-all",
                        }}
                      >
                        {t("Documents")}
                      </div>
                    </div>
                    <hr
                      className={document ? "horizontalDoc22" : "horizontal1"}
                    />
                  </div>
                  {packageID === process.env.REACT_APP_IS_PREMIUM && (
                    <div className="col-6 col-md-3 p-0 hidefor-Mobile">
                      <div className="hidefor-Mobile">
                        <div
                          className={
                            timeOff
                              ? "tagcolor documents-update pt-5 hidefor-Mobile"
                              : "documents2 pt-5 hidefor-Mobile"
                          }
                          onClick={() => handleTabChange("timeoff")}
                          style={{
                            wordBreak: "break-all",
                          }}
                        >
                          {/* Time Off */}
                          {t("Time OFF")}
                        </div>
                      </div>
                      <hr
                        className={timeOff ? "horizontalDoc22" : "horizontal1"}
                      />
                    </div>
                  )}
                </div>

                {/* ///////// INFORMATION TAB ///////// */}

                {information && (
                  <div>
                    <div className="px-4 mx-2 py-5">
                      <SelectNav
                        items={informationNavItems}
                        setSelectedItem={setSelectedInformationNav}
                        selectedItem={selectedInformationNav}
                        setErrors={setNavErrors}
                        personalForm={personalForm}
                      >
                        {selectedInformationNav === "Personal" ||
                        selectedInformationNav === "Persoonlijk" ? (
                          <PersonalInfoForm
                            personalForm={personalForm}
                            setPersonalForm={setPersonalForm}
                            FetchLanguagesData={FetchLanguagesData}
                            errors={navErrors}
                            setErrors={setNavErrors}
                            updateScreen={true}
                            ascTakingDatafromChild={ascTakingDatafromChild}
                          />
                        ) : selectedInformationNav === "Legal" ||
                          selectedInformationNav === "Juridisch" ? (
                          <LegalInformationForm
                            legalForm={legalForm}
                            setLegalForm={setLegalForm}
                            idsType={idsType}
                            employeeType={employeeType}
                            contractType={contractType}
                            FetchJobtypesdata={FetchJobtypesdata}
                          />
                        ) : selectedInformationNav === "Financial" ||
                          selectedInformationNav === "Financieel" ? (
                          <BankAccountForm
                            bankAccounts={bankAccounts}
                            setBankAccounts={setBankAccounts}
                          />
                        ) : selectedInformationNav === "Benefits" ||
                          selectedInformationNav === "Voordelen" ? (
                          <CompanyCarForm
                            transportForm={transportForm}
                            setTransportForm={setTransportForm}
                            fetchedReasons={fetchedReasons}
                            companyCar={companyCar}
                          />
                        ) : selectedInformationNav === "Certification" ||
                          selectedInformationNav === "Certificering" ? (
                          <CertificationList
                            certificationList={certificationList}
                            setCertificationsList={setCertificationsList}
                            totalCertifications={totalCertifications}
                            setTotalCertifications={setTotalCertifications}
                            insertedDoc={insertedDoc}
                          />
                        ) : selectedInformationNav === "Provided Items" ||
                          selectedInformationNav === "Geleverde artikelen" ? (
                          <ProvidedItems
                            providedItems={providedItems}
                            setProvidedItems={setProvidedItems}
                          />
                        ) : (
                          ""
                        )}
                      </SelectNav>
                      <div className="d-flex justify-content-between mt-xxl-5 pt-xxl-5">
                        <div className="align-items-end pt-5 mt-xxl-5  col-6 hidefor-Mobile">
                          <p
                            style={{
                              color: "#333333",
                              fontSize: "10px",
                              wordBreak: "break-all",
                            }}
                          >
                            {t("History")}
                          </p>
                          <div className="d-flex hidefor-Mobile">
                            <p
                              style={{
                                color: "#a5a5a5",
                                fontSize: "10px",
                              }}
                            >
                              {t("Last Change")}:
                            </p>
                            <p
                              className="ms-2"
                              style={{
                                color: "#a5a5a5",
                                fontSize: "10px",
                              }}
                            >
                              {/* {moment(updatedon).format("MMMM DD, YYYY")} */}
                              {moment(updatedon).format("DD.MM.YYYY")}
                              {/* {updatedon} */}
                            </p>
                          </div>
                        </div>
                        {/* <div className="d-flex justify-content-end  gap-4 mt-xxl-5  pt-5 col-6">
                          <button className="canclebtn-update cancle-btn-aspect-ratio invite-btn-aspect-ratio" onClick={handelCancels} style={{ wordBreak: "break-all" }}>
                            {fetchTransUpdateCoWorkers[14]?.translation}
                          </button>
                          <button disabled={editdetailsofcoWorker === false} className="invitebtn-update invite-btn-aspect-ratio" onClick={handleChange} style={{ wordBreak: "break-all" }}>
                            {fetchTransUpdateCoWorkers[15]?.translation}
                          </button>
                        </div> */}
                      </div>
                    </div>
                  </div>
                )}

                {/* /////// WAGE AND ROLE TAB ////////////// */}

                {wage && (
                  <div className="" style={{ backgroundColor: "white" }}>
                    <div className="pt-3 mt-2  px-3">
                      <div
                        className="justify-content-between text-align-start wage-role-table-flex"
                        style={{
                          display: "grid",
                          gridTemplateColumns:
                            "repeat(auto-fit, minmax(0px, 1fr))",
                          gap: "20px",
                        }}
                      >
                        <div
                          className="row mobileView1"
                          style={{
                            width: "100%",
                          }}
                        >
                          <div className="col-6 col-md-4 col-lg-6">
                            <p className="wage-common-font">{t("Wage Rate")}</p>
                            <hr className="mb-2" />
                            <div className="common-font">
                              <CurrencyInput
                                className="noborder2"
                                placeholder="€ 0,00"
                                // value={wagerate}
                                value={parseFloat(wagerate)}
                                ref={refNewStandardWageInput}
                                onChangeEvent={(
                                  event,
                                  maskedvalue,
                                  floatvalue,
                                ) => {
                                  setWagerate(floatvalue);
                                  setChangeComp(event.target.value);
                                }}
                                style={{
                                  color: "#333333",
                                  // width: "150px",
                                  fontSize: "clamp(14px, 1.025vw, 0.833vw)",
                                  fontWeight: "bold",
                                }}
                                decimalSeparator=","
                                thousandSeparator="."
                                precision="2"
                                allowEmpty={true}
                                prefix="€ "
                              />
                            </div>
                          </div>
                          <div className="col-6 col-md-4 col-lg-6">
                            <p
                              className="wage-common-font"
                              style={{
                                whiteSpace: "nowrap",
                              }}
                            >
                              {t("Payment Period")}
                            </p>
                            <hr className="mb-2" />
                            <div className="common-font">
                              <div
                                style={{
                                  cursor: "pointer",
                                  position: "relative",
                                  display: "flex",
                                  flexDirection: "row",
                                  // marginTop:"5px"
                                }}
                              >
                                <div
                                  ref={refPaymentTypeDropDownContainerExclude}
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                  onClick={() =>
                                    setShowPaymentDrop(!showPaymentDrop)
                                  }
                                >
                                  <p
                                    className="margin-0"
                                    style={{
                                      fontSize: "clamp(14px, 1.025vw, 0.833vw)",
                                      fontWeight: "bold",
                                      color: "#333333",
                                      flexGrow: "1",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {paymentperiod
                                      ? paymentperiod
                                      : t("Type a IBAN")}
                                  </p>
                                  <BsChevronDown
                                    size={10}
                                    style={{
                                      marginTop: "5px",
                                      flexGlow: "1",
                                      color: "#333333",
                                    }}
                                    className={`${
                                      showPaymentDrop
                                        ? "down-arrow down-arrow-rotate bi-paperclip me-4"
                                        : "down-arrow bi-paperclip me-4"
                                    }`}
                                  />
                                </div>
                                {showPaymentDrop && (
                                  <div
                                    className="drop-down-pyment"
                                    id="lang-drop-down"
                                    ref={refPaymentTypeDropDownContainer}
                                  >
                                    {pymentoptions?.map((item, i) => {
                                      return (
                                        <div
                                          className={
                                            item?.value === paymentperiod
                                              ? " typ-list-select typ-list"
                                              : "typ-list"
                                          }
                                          // className=''
                                        >
                                          <p
                                            key={i}
                                            className="margin-0 ms-3 pb-1"
                                            style={{
                                              opacity: 1,
                                              fontSize:
                                                "clamp(14px, 1.025vw, 0.833vw)",
                                              fontWeight: 400,
                                              color: "#333333",
                                            }}
                                            onClick={() => {
                                              // setStatusId(item.id);
                                              setPaymentperiod(item.value);
                                              setShowPaymentDrop(false);
                                              setChangeComp(item.value);
                                            }}
                                          >
                                            {item.value}
                                          </p>
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="row mobileView1"
                          style={{
                            width: "100%",
                          }}
                        >
                          <div className="col-6 col-md-4 col-lg-6">
                            <p className="wage-common-font">{t("Bill Rate")}</p>
                            <hr className="mb-2" />
                            <div className="common-font">
                              <CurrencyInput
                                className="noborder2"
                                placeholder="€ 0,00"
                                // value={billrate}
                                value={parseFloat(billrate)}
                                ref={refNewStandardWageInput}
                                onChangeEvent={(
                                  event,
                                  maskedvalue,
                                  floatvalue,
                                ) => {
                                  setBillrate(floatvalue);
                                  setChangeComp(event.target.value);
                                }}
                                style={{
                                  color: "#333333",
                                  fontSize: "clamp(14px, 1.025vw, 0.833vw)",
                                  fontWeight: "bold",
                                }}
                                decimalSeparator=","
                                thousandSeparator="."
                                precision="2"
                                allowEmpty={true}
                                prefix="€ "
                              />
                            </div>
                          </div>

                          <div className="col-6 col-md-4 col-lg-6">
                            <p className="wage-common-font">{t("Type")}</p>
                            <hr className="mb-2" />
                            <div className="common-font">
                              <div
                                style={{
                                  cursor: "pointer",
                                  position: "relative",
                                  display: "flex",
                                  flexDirection: "row",
                                  // width: "60px",
                                }}
                              >
                                <div
                                  onClick={() => setShowTypeDrop(!showTypeDrop)}
                                  ref={refTypeDropDownContainerExclude}
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <p
                                    className="margin-0 "
                                    style={{
                                      // marginLeft: "3px",
                                      fontSize: "clamp(14px, 1.025vw, 0.833vw)",
                                      fontWeight: "bold",
                                      color: "#333333",
                                      flexGrow: "1",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {type ? type : t("Type a IBAN")}
                                  </p>
                                  <BsChevronDown
                                    size={10}
                                    style={{
                                      marginTop: "5px",
                                      flexGlow: "1",
                                      color: "#333333",
                                    }}
                                    className={`${
                                      showTypeDrop
                                        ? "down-arrow down-arrow-rotate bi-paperclip me-4"
                                        : "down-arrow bi-paperclip me-4"
                                    }`}
                                  />
                                </div>
                                {showTypeDrop && (
                                  <div
                                    className="drop-down-pyment"
                                    id="lang-drop-down"
                                    ref={refTypeDropDownContainer}
                                  >
                                    {typeoptions?.map((item, i) => {
                                      return (
                                        <div
                                          className={
                                            item.value === type
                                              ? " typ-list-select typ-list"
                                              : "typ-list"
                                          }
                                          // className=''
                                        >
                                          <p
                                            key={i}
                                            className="margin-0 ms-3 pb-1"
                                            style={{
                                              opacity: 1,
                                              fontSize:
                                                "clamp(14px, 1.025vw, 0.833vw)",
                                              color: "#333333",
                                              fontWeight: 400,
                                              margin: "0px 0px 0px 16px",
                                            }}
                                            onClick={() => {
                                              // setStatusId(item.id);
                                              setType(item.value);
                                              setShowTypeDrop(false);
                                              setChangeComp(item.value);
                                            }}
                                          >
                                            {item.value}
                                          </p>
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="row mobileView1"
                          style={{
                            width: "100%",
                          }}
                        >
                          <div className="col-6 col-md-4 col-lg-6">
                            <p className="wage-common-font">
                              {t("Payroll")}
                              {/* Payroll */}
                            </p>
                            <hr className="mb-2" />

                            <input
                              type="checkbox"
                              // checked={item.checked}
                              className="form-check-input pointer companyRadio ms-"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginLeft: "1rem",
                              }}
                              value={payroll}
                              checked={payroll}
                              onChange={() => {
                                setPayRoll((prev) => !prev);
                              }}
                            />
                          </div>

                          <div className="col-6 col-md-4 col-lg-6">
                            <p
                              className="wage-common-font"
                              style={{
                                whiteSpace: "nowrap",
                              }}
                            >
                              {t("Timesheet approval")}
                              {/* Timesheet approval */}
                            </p>
                            <hr className="mb-2" />
                            <input
                              type="checkbox"
                              // checked={item.checked}
                              className="form-check-input pointer companyRadio ms-"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginLeft: "1rem",
                              }}
                              value={timesheetapproval}
                              checked={timesheetapproval}
                              onChange={() => {
                                setTimeSheetApproval((prev) => !prev);
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="my-xxl-5 py-4 hidefor-Mobile">
                        <div
                          style={{
                            backgroundColor: "#e4edfa",
                            display: "flex",
                            flexWrap: "wrap",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "10px",
                            borderRadius: "10px",
                            fontSize: 13,
                            width: "100%",
                            maxWidth: "100%",
                            overflow: "auto",
                          }}
                        >
                          <div
                            className="py-2"
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              fontWeight: 500,
                              width: "40%",
                              gap: "10px",
                            }}
                          >
                            <div>
                              {/* Working Time */}
                              {t("Working Time")}
                              <span
                                style={{
                                  fontWeight: 300,
                                  marginLeft: "10px",
                                }}
                              >
                                {/* Total Even week */}
                                {t("Total Even week")}
                              </span>
                            </div>
                            <div>{evenWorkingHours}</div>
                          </div>
                          <div
                            className="py-2"
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              fontWeight: 500,
                              width: "40%",
                              gap: "10px",
                            }}
                          >
                            <div>
                              {/* Total Odd week */}
                              {t("Total Odd week")}
                            </div>
                            <div>{oddWorkingHours}</div>
                          </div>
                          <div
                            className="py-2"
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "center",
                              marginRight: "40px",
                              fontWeight: 300,
                              fontSize: 12,
                            }}
                          >
                            {t("Apply to all year")}
                            {/* Apply to all year */}
                            <input
                              type="checkbox"
                              checked={applyToAllYear}
                              className="form-check-input pointer companyRadio ms-"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginLeft: "1rem",
                              }}
                              onChange={(e) => {
                                setApplyToAllYear((prev) => !prev);
                              }}
                            />
                          </div>
                        </div>
                        <div
                          style={{
                            // backgroundColor: "#e4edfa",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "10px",
                            fontSize: 13,
                            width: "100%",
                            color: "37f857d",
                            maxWidth: "100%",
                            overflow: "auto",
                          }}
                        >
                          <span
                            style={{
                              margin: 0,
                              marginRight: "10px",
                              fontSize: 12,
                              width: "100%",
                            }}
                          >
                            {" "}
                            {/* Even Week */}
                            {t("Even Week")}
                          </span>
                          {Object.keys(evenDays).map((day, index) => {
                            let finalDay = day.slice(0, 3).split("");
                            finalDay = `${finalDay[0].toUpperCase()}${finalDay
                              .join("")
                              .slice(1, 3)}`;
                            return (
                              <div
                                index={index}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                <div>{finalDay}</div>
                                <input
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor:
                                      evenDays[day] != 0 ? "#e4edfa" : "white",
                                    color: "#333333",
                                    padding: "10px 30px",
                                    borderRadius: "10px",
                                    border: "1px dashed #e8e8e8",
                                    width: "5.5rem",
                                    fontWeight: 500,
                                  }}
                                  value={evenDays[day]}
                                  onChange={(e) => {
                                    if (
                                      (!isNaN(parseInt(e.target.value)) &&
                                        parseInt(e.target.value) <= 8) ||
                                      e.target.value === ""
                                    ) {
                                      const existing = {
                                        ...evenDays,
                                      };
                                      const day = Object.keys(existing)[index];
                                      existing[day] = e.target.value;
                                      setEvenDays(existing);
                                    }
                                  }}
                                />
                              </div>
                            );
                          })}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "10px",
                            fontSize: 13,
                            width: "100%",
                            color: "37f857d",
                            maxWidth: "100%",
                            overflow: "auto",
                          }}
                        >
                          <span
                            style={{
                              margin: 0,
                              marginRight: "10px",
                              fontSize: 12,
                              width: "100%",
                            }}
                          >
                            {" "}
                            {t("Odd Week")}
                            {/* Odd Week */}
                          </span>
                          {Object.keys(oddDays).map((day, index) => {
                            return (
                              <div
                                index={index}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                {/* <div>{day.slice(0, 3).toUpperCase()}</div> */}
                                <input
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor:
                                      oddDays[day] != 0 ? "#e4edfa" : "white",
                                    color: "#333333",
                                    padding: "10px 30px",
                                    borderRadius: "10px",
                                    border: "1px dashed #e8e8e8",
                                    width: "5.5rem",
                                    fontWeight: 500,
                                  }}
                                  value={oddDays[day]}
                                  onChange={(e) => {
                                    if (
                                      (!isNaN(parseInt(e.target.value)) &&
                                        parseInt(e.target.value) <= 8) ||
                                      e.target.value === ""
                                    ) {
                                      const existing = {
                                        ...oddDays,
                                      };
                                      const day = Object.keys(existing)[index];
                                      existing[day] = e.target.value;
                                      setOddDays(existing);
                                    }
                                  }}
                                />
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      <div className="mt-5 pt-xxl-4 pt-xl-5 pt-lg-5 pb-5">
                        <div className="text-start">
                          <p className="wage-common-font ms-2 mt-4">
                            {t("Authorisation Role")}
                          </p>
                        </div>
                        <div className="row pb-4" aria-disabled>
                          <div className="col-8">
                            <div
                              className="row roles-options roles-options-onmobile"
                              style={{
                                marginLeft: "0px",
                              }}
                            >
                              <Col
                                className="p-0"
                                style={{
                                  height: "100%",
                                }}
                              >
                                <p
                                  style={
                                    roleid === process.env.REACT_APP_IS_OWNER
                                      ? {
                                          backgroundColor: `#00246A`,
                                        }
                                      : {
                                          backgroundColor: ``,
                                        }
                                  }
                                  className={
                                    roleid === process.env.REACT_APP_IS_OWNER
                                      ? "role-single-add authorisation-roles active-role active-role-response"
                                      : roleAccess ===
                                          process.env.REACT_APP_IS_MANAGER
                                        ? "pointerEvent role-single-add wage-authorisation-roles"
                                        : "role-single-add wage-authorisation-roles "
                                  }
                                  onClick={() => {
                                    // if (roleOwnerDiseble) {
                                    setAuthorisationRole("Owner");
                                    setRoleid(
                                      "08da3f0d-0371-4dd3-8c86-e51222d56188",
                                    );
                                    setChangeComp(
                                      process.env.REACT_APP_IS_OWNER,
                                    );
                                    // }
                                  }}
                                >
                                  {t("Owner")}
                                </p>
                              </Col>
                              <Col
                                style={{
                                  height: "100%",
                                }}
                              >
                                <p
                                  style={
                                    roleid ===
                                    "08da3f0d-0371-4dd3-8c86-e51222d56199"
                                      ? {
                                          backgroundColor: `#00246A`,
                                        }
                                      : {
                                          backgroundColor: ``,
                                        }
                                  }
                                  className={
                                    roleid === process.env.REACT_APP_IS_MANAGER
                                      ? "role-single-add wage-authorisation-roles active-role active-role-response"
                                      : "role-single-add wage-authorisation-roles "
                                  }
                                  onClick={() => {
                                    // if (
                                    //   roleManagerDiseble ||
                                    //   roleOwnerDiseble
                                    // ) {
                                    setAuthorisationRole("Manager");
                                    setRoleid(
                                      "08da3f0d-0371-4dd3-8c86-e51222d56190",
                                    );
                                    setChangeComp(
                                      "08da3f0d-0371-4dd3-8c86-e51222d56190",
                                    );
                                    // }
                                  }}
                                >
                                  {t("Manager")}
                                </p>
                              </Col>
                              <Col
                                style={{
                                  height: "100%",
                                }}
                              >
                                <p
                                  style={
                                    roleid === process.env.REACT_APP_IS_USER
                                      ? {
                                          backgroundColor: `#00246A`,
                                        }
                                      : {
                                          backgroundColor: ``,
                                        }
                                  }
                                  className={
                                    roleid === process.env.REACT_APP_IS_USER
                                      ? "role-single-add wage-authorisation-roles active-role active-role-response"
                                      : "role-single-add wage-authorisation-roles "
                                  }
                                  onClick={() => {
                                    // if (
                                    //   roleManagerDiseble ||
                                    //   roleOwnerDiseble
                                    // ) {
                                    setAuthorisationRole("User");
                                    setRoleid(
                                      "08da3f0d-0371-4dd3-8c86-e51222d56189",
                                    );
                                    setChangeComp(
                                      "08da3f0d-0371-4dd3-8c86-e51222d56189",
                                    );
                                    // }
                                  }}
                                >
                                  {t("User")}
                                </p>
                              </Col>
                              <Col
                                className="p-0"
                                style={{
                                  height: "100%",
                                }}
                              >
                                <p
                                  style={
                                    roleid === process.env.REACT_APP_IS_VIEWER
                                      ? {
                                          backgroundColor: "#00246A",
                                        }
                                      : {
                                          backgroundColor: ``,
                                        }
                                  }
                                  className={
                                    roleid === process.env.REACT_APP_IS_VIEWER
                                      ? "role-single-add wage-authorisation-roles active-role active-role-response"
                                      : "role-single-add wage-authorisation-roles "
                                  }
                                  onClick={() => {
                                    // if (
                                    //   roleManagerDiseble ||
                                    //   roleOwnerDiseble
                                    // ) {
                                    setAuthorisationRole("Freelancer");
                                    setRoleid(
                                      "08da3f0d-0371-4dd3-8c86-e51222d56191",
                                    );
                                    setChangeComp(
                                      process.env.REACT_APP_IS_VIEWER,
                                    );
                                    // }
                                  }}
                                >
                                  {t("Viewer")}
                                </p>
                              </Col>
                            </div>
                          </div>
                          <div className="col-3 ">
                            <div
                              className="ms-0 ms-sm-5"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                marginLeft: 30,
                                marginTop: 5,
                              }}
                            >
                              <div
                                style={{
                                  color: "rgba(51, 51, 51, 1)",
                                  fontSize: 11,
                                }}
                              >
                                {/* Active? */}
                                {t("Active")}?
                              </div>
                              <StyledSwitch
                                className="profiletoggle"
                                onChange={() =>
                                  setActiveSlider((prev) => !prev)
                                }
                                checked={activeSlider}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/*///////// DOCUMENT TAB /////////////////// */}

                {document && (
                  <div className="  m-4 mt-3 ">
                    <SelectNav
                      items={documentNavItems}
                      setSelectedItem={setSelectedDocumentNav}
                      selectedItem={selectedDocumentNav}
                      setErrors={setNavErrors}
                      screen="documents"
                    >
                      <div style={{ width: "100%" }}>
                        <div
                          className="table-doc-info"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div className="d-flex pt-1">
                            <DocumentUploaderWithProgress
                              maxSizeInMb={100}
                              onUploaded={onFileUploaded}
                            >
                              <label
                                htmlFor="add-attachment"
                                className="mx"
                                style={{
                                  display: "flex",
                                  alignItems: "center",

                                  cursor: "pointer",
                                }}
                              >
                                <img
                                  src={adddoc}
                                  alt="addicons"
                                  className="mb-3 plus-icon-aspect-ratio"
                                />
                                <p
                                  className="mx-2 ft"
                                  style={{
                                    wordBreak: "break-all",
                                    fontSize: "clamp(12px, 0.833vw, 0.833vw)",
                                  }}
                                >
                                  {t("Add Doc")}
                                </p>
                              </label>
                            </DocumentUploaderWithProgress>
                          </div>
                          <div className="custom-pagination">
                            <div className="range-text">
                              {`${paginationObj.startRecordIndex} - ${paginationObj.endRecordIndex} of ${paginationObj.totalRecords}`}
                            </div>
                            <div className="pagination-buttons">
                              <div
                                className={`update-member-pagination-button ${
                                  paginationObj.currentPage === 1
                                    ? "disabled"
                                    : ""
                                }`}
                                onClick={() =>
                                  calculatePagination(
                                    paginationObj.currentPage - 1,
                                  )
                                }
                              >
                                <BsChevronLeft />
                              </div>
                              <div className="pagination-current-page">
                                {paginationObj.currentPage}
                              </div>
                              <div
                                className={`update-member-pagination-button ${
                                  paginationObj.totalPages === 0 ||
                                  paginationObj.totalPages ===
                                    paginationObj.currentPage
                                    ? "disabled"
                                    : ""
                                }`}
                                onClick={() =>
                                  calculatePagination(
                                    paginationObj.currentPage + 1,
                                  )
                                }
                              >
                                <BsChevronRight />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div
                            className="col-5 ft document-header"
                            style={{
                              textAlign: "initial",
                              wordBreak: "break-all",
                            }}
                          >
                            {t("Name")}
                          </div>
                          <div
                            className="col-2 ft document-header hidefor-Mobile"
                            style={{
                              wordBreak: "break-all",
                            }}
                          >
                            {t("Size")}
                          </div>
                          <div
                            className="col-2 ft document-header hidefor-Mobile"
                            style={{
                              wordBreak: "break-all",
                            }}
                          >
                            {t("Date")}
                          </div>
                          <div
                            className="col-2 pe-4 ft text-align-end document-header hidefor-Mobile"
                            style={{
                              wordBreak: "break-all",
                            }}
                          >
                            {t("Sender")}
                          </div>
                        </div>
                        <hr
                          style={{
                            height: "",
                            border: "0.5px dashed #C0C5C5",
                          }}
                          className="my-1"
                        />
                        <div
                          className=""
                          style={{
                            height: "260px",
                            overflowY: "auto",
                            overflowX: "hidden",
                          }}
                        >
                          {paginationObj.records.map((item, i) => {
                            const filesize1 = (
                              item?.documentsize / 1024
                            ).toString();
                            return (
                              <>
                                <div className="row my-1">
                                  <div className="d-flex">
                                    <div
                                      className="col-9 col-md-5 col-sm-6 ps-1 ft"
                                      style={{
                                        textAlign: "initial",
                                        color: "#333333",
                                        cursor: "default",
                                      }}
                                    >
                                      <LightTooltip
                                        disableHoverListener={
                                          item.documentname?.length > 30
                                            ? false
                                            : true
                                        }
                                        title={item.documentname}
                                        placement="top-start"
                                      >
                                        <div
                                          style={{
                                            width: "16vw",
                                            fontWeight: 400,
                                          }}
                                          className="truncated-text1 document-content"
                                          onClick={(event) =>
                                            pdfdownload(
                                              event,
                                              item?.documentid,
                                              item.documentname,
                                            )
                                          }
                                        >
                                          {item.documentname}
                                        </div>
                                      </LightTooltip>
                                    </div>
                                    <div
                                      className="col-2 ft document-content hidefor-Mobile"
                                      style={{
                                        color: "#333333",
                                      }}
                                    >
                                      {roundFileSize(item?.documentsize, 2)}
                                      {/* {filesize1 > 1024
                                    ?   ((filesize1 / 1024)?.toFixed(2)
                                       + "MB")
                                    :filesize1 < 1024 ?
                                     (`${filesize1.toFixed(2)}`) + "KB":""} */}
                                    </div>
                                    <div
                                      className=" ms-2 col-2 ft document-content hidefor-Mobile"
                                      style={{
                                        color: "#333333",
                                      }}
                                    >
                                      {moment(item.date).format("DD.MM.YYYY")}
                                    </div>

                                    <div
                                      className="col-3 ft pe-4"
                                      style={{
                                        justifyContent: "flex-end",
                                        display: "flex",
                                        gap: "15px",
                                      }}
                                    >
                                      {item.uploadedby ? (
                                        <img
                                          className="me-4 hidefor-Mobile"
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                            borderRadius: "50%",
                                            objectFit: "cover",
                                          }}
                                          src={item.uploadedby}
                                          alt=""
                                        />
                                      ) : item?.uploadedbyfirstname ? (
                                        <div
                                          className=" me-4"
                                          style={{
                                            width: " 1.458vw",
                                            height: "1.458vw",
                                            minWidth: "20px",
                                            minHeight: "20px",
                                            borderRadius: "50%",
                                            objectFit: "cover",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",

                                            color: "#FFFFFF",
                                            fontsize:
                                              "clamp(14px, 0.833vw, 0.833vw)",
                                            fontWeight: 400,
                                            background:
                                              "#95A7C6 0% 0% no-repeat padding-box",
                                          }}
                                        >
                                          {item?.uploadedbyfirstname?.toUpperCase()
                                            ? item?.uploadedbyfirstname
                                                .slice(0, 1)
                                                .toUpperCase() +
                                              item?.uploadedbylastname
                                                .slice(0, 1)
                                                .toUpperCase()
                                            : item?.uploadedbyfirstname
                                                ?.slice(0, 1)
                                                .toUpperCase() +
                                              item?.uploadedbyfirstname
                                                ?.slice(1, 2)
                                                .toUpperCase()}
                                        </div>
                                      ) : (
                                        <div
                                          className="fromSystem me-4"
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                            borderRadius: "50%",
                                            objectFit: "cover",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",

                                            color: "#FFFFFF",
                                            fontsize:
                                              "clamp(14px, 0.833vw, 0.833vw)",
                                            fontWeight: 400,
                                            background:
                                              "#95A7C6 0% 0% no-repeat padding-box",
                                          }}
                                        >
                                          {userfirstname?.toUpperCase()
                                            ? userfirstname
                                                .slice(0, 1)
                                                .toUpperCase() +
                                              userlastname
                                                .slice(0, 1)
                                                .toUpperCase()
                                            : userfirstname
                                                ?.slice(0, 1)
                                                .toUpperCase() +
                                              userfirstname
                                                ?.slice(1, 2)
                                                .toUpperCase()}
                                        </div>
                                      )}

                                      <img
                                        style={{
                                          cursor: "pointer",
                                          width:
                                            "clamp(17px, 1.146vw, 1.146vw)",
                                          height:
                                            "clamp(18px, 2.3148vh, 2.6852vh)",
                                        }}
                                        className="me-2"
                                        src={del}
                                        alt=" "
                                        onClick={() => {
                                          setDeleteRowIndex(item.documentid);
                                          setDeleteDocument(true);
                                        }}
                                      />

                                      <div className="pointer">
                                        <EyeOutlined
                                          onClick={() => {
                                            setFilePreview(
                                              getFilePreview({
                                                // file: file, // local upload file
                                                url: item.link,
                                                type: item.link
                                                  .split(".")
                                                  .pop(),
                                                name: item.documentname,
                                              }),
                                            );
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            );
                          })}
                        </div>

                        <FilePreviewModal
                          open={filePreview}
                          file={filePreview}
                          onClose={() => setFilePreview(null)}
                        />

                        {/* <div className='mt- pt-'></div> */}
                        {/* <div className='pt-5 mt-5'></div> */}
                      </div>
                    </SelectNav>

                    <div className="d-flex justify-content-between mt-xxl-5 mt-xl-4 mt-lg-4 pt-xxl-5 pt-xl-1 pt-lg-1 hidefor-Mobile">
                      <div className="align-items-end pt-5 ">
                        <p
                          style={{
                            color: "#333333",
                            fontSize: "10px",
                            wordBreak: "break-all",
                          }}
                        >
                          {t("History")}
                        </p>
                        <div className="d-flex">
                          <p
                            style={{
                              color: "#a5a5a5",
                              fontSize: "10px",
                              wordBreak: "break-all",
                            }}
                          >
                            {t("Last Change")}:{" "}
                          </p>
                          <p
                            className="ms-2"
                            style={{
                              color: "#a5a5a5",
                              fontSize: "10px",
                            }}
                          >
                            {" "}
                            {moment(updatedon).format("DD.MM.YYYY")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {timeOff && (
                  <TimeOffScreen
                    timeOffEntries={timeOffEntries}
                    setTimeOffEntries={setTimeOffEntries}
                    FetchUserData={FetchActiveUserData}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* add button for mobile view start */}
        <div className="d-flex justify-content-center gap-4 addcancelbttn">
          <button
            className="canclebtn-add invite-btn-aspect-ratio cancle-btn-aspect-ratio d-none upperADD_CancelBtnShoeHide_Mobile"
            onClick={handelCancels}
            style={{ wordBreak: "break-all" }}
          >
            {t("Cancel ")}
          </button>
          <button
            disabled={
              editdetailsofcoWorker === false ||
              (personalForm.firstname &&
              personalForm.email &&
              personalForm.initials &&
              personalForm.password
                ? false
                : true)
            }
            className="invitebtn-add-member invite-btn-aspect-ratio d-none upperADD_CancelBtnShoeHide_Mobile"
            onClick={handleChange}
            style={{ wordBreak: "break-all" }}
          >
            {t("Change")}
          </button>
        </div>
        {/* add button for mobile view end */}
      </div>

      {popups && (
        <Modal
          show={popups}
          className="modelwidth12 modal-dialog1"
          style={{
            backgroundColor: "transparent",
            opacity: 0.9,
          }}
          id="update-member-modal"
          centered
        >
          <Modal.Body>
            <div className="flex_class my-5">
              <div
                className=" "
                style={{
                  color: "#333333",
                  fontSize: "14px",
                  fontWeight: 700,
                }}
              >
                {t("The changes made will not be saved.")}
              </div>

              <div
                className=" mt-4"
                style={{
                  color: "#333333",
                  fontSize: "14px",
                  fontWeight: 700,
                }}
              >
                {t("Do you want to proceed?")}
              </div>

              <div className="mt-5 ">
                <button
                  className="me-2  btn-no-add-edit-member"
                  onClick={() => {
                    setPopups(false);
                  }}
                  style={{ fontWeight: 800 }}
                >
                  {t("No")}
                </button>
                <button
                  className="ms-2  btn-yes-add-edit-member"
                  onClick={() => {
                    history.goBack();
                  }}
                  style={{ fontWeight: 800 }}
                >
                  {t("Yes")}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
      {deleteModalShow && (
        <DeletePopUp
          animation={true}
          handleDelete={handleDeleteFun}
          show={deleteModalShow}
          onHide={() => setDeleteModalShow(false)}
          title1={"This data will be removed from the system"}
          title2={"and cannot be undone."}
          title3={t("Do you want to proceed?")}
          no={t("No")}
          yes={t("Yes")}
        />
      )}
      {deleteDocument && (
        <DeletePopUp
          animation={true}
          handleDelete={handleDeleteDocumentFun}
          show={deleteDocument}
          onHide={() => setDeleteDocument(false)}
          title1={"This data will be removed from the system"}
          title2={"and cannot be undone."}
          title3={t("Do you want to proceed?")}
          no={t("No")}
          yes={t("Yes")}
        />
      )}
    </>
  );
};

export default UpdateMember;
